import { useTranslation } from "react-i18next"
import { CustomChipInfoProps } from "./ChipInfo.interfaces"
import { Chip, useTheme } from "@mui/material"
import { StyledFontAwesomeIcon } from "./ChipInfo.styled"

const ChipInfoIcon = ({ icon, text, border, chip }: CustomChipInfoProps) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const iconSize = icon?.size || 1
  const iconColor = icon?.color || (theme.palette as any).sky[700]
  const textColor = text?.color || (theme.palette as any).sky[700]
  const borderThickness = border?.thickness || 1
  const borderColor = border?.color || (theme.palette as any).sky[700]
  const chipColor = chip?.color || 'primary'
  const chipBackgroundColor = chip?.backgroundColor || (theme.palette as any).sky[100]

  return (
    <Chip
      variant={chip?.variant || 'outlined'}
      color={chipColor}
      icon={icon?.source ?
        <StyledFontAwesomeIcon
          size={`${iconSize}x` as any}
          icon={icon?.source}
          color={iconColor}
        /> : <></>}
      label={text?.data || t("", "")}
      sx={{
        borderRadius: '4px',
        fontWeight: 500,
        fontSize: text?.size || 14,
        '& .MuiChip-label': {
          paddingRight: '8px !important',
        },
        borderColor: borderColor,
        borderWidth: borderThickness,
        backgroundColor: chipBackgroundColor,
        color: textColor,
      }}
    />
  )
}

export default ChipInfoIcon
